import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Box, Grid } from '@mui/material';
import clsx from 'clsx';

import { TextInputControl } from 'components/_basic/Form/TextInput';
import { TooltipComponent } from 'components/_basic/TooltipComponent';
import { TOOLTIP_VARIANT } from 'components/_basic/TooltipComponent/constants';

import { concatWithDot } from 'helpers/string';

import { IFieldTableHeaderProps } from './types';
import { FieldTableWatchedRowTitle } from '../FieldTableRowTitle';

import styles from './FieldTableHeader.module.scss';

export const FieldTableHeader: React.FC<IFieldTableHeaderProps> = ({
  name,
  disabled,
  columnsNames,
  firstColumnWidth,
  firstColumnClass = '',
  editableColumn,
  titleColumnGap = 2,
}) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  return (
    <Grid container sx={{ marginBottom: '12px' }} wrap="nowrap" gap={titleColumnGap}>
      <Grid
        item
        className={clsx(styles.flexCenter, firstColumnClass)}
        sx={{ width: firstColumnWidth, minWidth: firstColumnWidth }}
      ></Grid>
      <Grid item xs>
        <Grid container spacing={1} columns={columnsNames.length} wrap="nowrap">
          {columnsNames.map((item) => {
            const inputName = concatWithDot(name, item);

            return (
              <Grid item xs={1} key={item}>
                {editableColumn ? (
                  <TooltipComponent title={t('rename')} variant={TOOLTIP_VARIANT.SMALL}>
                    <Box>
                      <TextInputControl
                        control={control}
                        id={inputName}
                        name={inputName}
                        className={clsx(styles.textInput)}
                        disabled={disabled}
                        sx={{ minWidth: 110 }}
                        variant="standard"
                        maxLength={20}
                      />
                    </Box>
                  </TooltipComponent>
                ) : (
                  <FieldTableWatchedRowTitle watchRowTitleName={inputName} />
                )}
              </Grid>
            );
          })}
        </Grid>
      </Grid>
    </Grid>
  );
};
